import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import DisplayImage from '../../display-image';
import CommonCard from '../common-card';
import Eyebrow from '@/components/Common/Eyebrow';
import parse from 'html-react-parser';
import {fadeInUp} from '@/animation/scroll-animation';
import {colors, fontSize, fontWeight, shadows} from '@/styles/tokens';
import {ICON_TILE_ICON_SIZE, iconTileImageStyle, iconTileSx} from '@/styles/iconTile';

// Imported normally (not client-only), so the cards it wraps are in the server HTML; it renders them visible on the
// server and only animates on the client.
import {AnimatedComponent} from '../../AnimatedComponent';
import Link from 'next/link';
import {sectionHeadingSx} from '@/styles/sectionHeading';

const baseOuterSx = {
    ...iconTileSx,
    boxShadow: shadows.lg
};

const cardSx = {minHeight: 260};
const bodySx = {color: colors.text.primary};

/**
 * The site-wide icon tile: 46×46, 4px padding, blue gradient background.
 * `size` is accepted for backwards compatibility with existing pages but no
 * longer changes the tile — every tile is one size so they stay consistent.
 */
export const CommonImageWrapper = (props: any) => {
    const {children, sx} = props;
    return (
        <Box className="common-icon-tile" sx={sx ? [baseOuterSx, sx] : baseOuterSx}>
            {children}
        </Box>
    );
};
const HomeServices = (props: any) => {
    const {eyebrow, heading, subheading, boldSubheading, contentData, blueHover} = props;
    return (
        <Box>
            <MUIContainer>
                <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={5}>
                    {eyebrow && <Eyebrow text={eyebrow} />}
                    <Typography variant="h1" component="h2" mb={3} className="font-headers" sx={sectionHeadingSx}>
                        {heading ? parse(heading) : ''}
                    </Typography>
                    {boldSubheading && (
                        <Typography variant="h3" component="p" mb={2} fontSize={{xs: 16, sm: 22}} className="font-headers">
                            {boldSubheading}
                        </Typography>
                    )}
                    <Typography variant="subtitle1" component="p" className="font-regular-text">
                        {subheading ? parse(subheading) : ''}
                    </Typography>
                </Box>
                <Box>
                    <Grid container spacing={3}>
                        {contentData?.map((item: any, index: number) => (
                            <Grid item xs={12} sm={6} md={4} key={item.heading}>
                                <AnimatedComponent variants={fadeInUp} delay={index * 0.2} className="height-full">
                                    <CommonCard sx={cardSx} blueHover={blueHover}>
                                        <CommonImageWrapper>
                                            {item.number ? (
                                                <Typography
                                                    component="span"
                                                    className="font-headers"
                                                    sx={{
                                                        color: colors.text.inverse,
                                                        fontSize: fontSize[24],
                                                        fontWeight: fontWeight.bold,
                                                        lineHeight: 1
                                                    }}
                                                >
                                                    {item.number}
                                                </Typography>
                                            ) : (
                                                <DisplayImage
                                                    alt={item.heading}
                                                    src={item.src}
                                                    className="home-service-icon"
                                                    width={ICON_TILE_ICON_SIZE}
                                                    height={ICON_TILE_ICON_SIZE}
                                                    style={iconTileImageStyle}
                                                />
                                            )}
                                        </CommonImageWrapper>
                                        {item.redirect ? (
                                            <Typography variant="h3" component="h3" mt={2} mb={2}>
                                                <Link
                                                    href={item.redirect}
                                                    target="_blank"
                                                    className="card-redirection-heading font-headers "
                                                >
                                                    {item.heading}
                                                </Link>
                                            </Typography>
                                        ) : (
                                            <Typography variant="h3" component="h3" mt={2} mb={2} className="font-headers">
                                                {item.heading}
                                            </Typography>
                                        )}

                                        <Typography variant="body1" className="font-regular-text" sx={bodySx}>
                                            {item.body ? parse(item.body) : ''}
                                        </Typography>
                                    </CommonCard>
                                </AnimatedComponent>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </MUIContainer>
        </Box>
    );
};

export default memo(HomeServices);
